import { useLanguage } from "../context/LanguageContext";
import PolicyPage, { type PolicyContent } from "./PolicyPage";
import { CONTACT_BIN, CONTACT_EMAIL } from "../data/contact";

const CONTENT: Record<"ru" | "kz", PolicyContent> = {
  ru: {
    title: "Доставка и оплата",
    updated: "Дата последнего обновления: 31 августа 2026 г.",
    intro: [
      "Компания BARCRAFT (ТОО «БАРКРАФТ») является поставщиком профессионального технологического оборудования для сектора HoReCa. Мы работаем исключительно с юридическими лицами и индивидуальными предпринимателями в рамках долгосрочного и профессионального партнерства.",
    ],
    sections: [
      {
        heading: "1. Условия и порядок оплаты",
        paragraphs: ["Мы придерживаемся гибкой финансовой политики и индивидуального подхода к каждому партнеру."],
        list: [
          "Налогообложение: все цены на сайте указаны с учетом НДС 16%.",
          "Индивидуальное согласование: условия, порядок и сроки оплаты согласовываются отдельно в индивидуальном порядке с каждым клиентом.",
          `Договорная основа: все достигнутые договоренности по платежам (размер предоплаты, график платежей, условия окончательного расчета) фиксируются в официальном Договоре поставки или Спецификации к заказу.`,
          `Форма расчета: оплата производится в безналичном порядке путем перечисления денежных средств на расчетный счет ТОО «БАРКРАФТ» (БИН: ${CONTACT_BIN}).`,
          "Валюта: все расчеты на территории Республики Казахстан осуществляются в тенге (KZT).",
        ],
      },
      {
        heading: "2. Сроки и условия отгрузки",
        paragraphs: ["Сроки поставки зависят от наличия оборудования на складе и сложности заказа:"],
        list: [
          "Товары в наличии: отгрузка со склада осуществляется в течение 10 рабочих дней после подтверждения оплаты в соответствии с условиями договора.",
          "Товары под заказ: срок поставки специфического или сложного технологического оборудования составляет от 14 до 90 календарных дней. Срок зависит от производственного цикла завода-изготовителя и условий международной логистики.",
        ],
      },
      {
        heading: "3. Доставка и получение товара",
        paragraphs: ["Мы организуем доставку оборудования по территории Республики Казахстан:"],
        list: [
          "Доставка по г. Астана: осуществляется бесплатно.",
          "Доставка по Казахстану: мы бесплатно доставим ваш заказ до терминала любой указанной вами транспортной компании (ТК) в черте города Астана. Межгородскую перевозку (от Астаны до вашего города) Покупатель оплачивает самостоятельно по тарифам выбранной ТК.",
          "Самовывоз: вы можете самостоятельно забрать товар с нашего склада в г. Астана по предварительному согласованию.",
        ],
      },
      {
        heading: "4. Правила приемки оборудования",
        paragraphs: ["Для получения оборудования представитель Покупателя обязан предоставить:"],
        list: ["Оригинал доверенности на получение ТМЦ.", "Документ, удостоверяющий личность."],
      },
      {
        heading: "5. Контакты",
        paragraphs: [
          "При приемке необходимо проверить целостность упаковки. Подписание товаросопроводительных документов подтверждает отсутствие претензий к количеству и внешнему виду товара.",
          `По вопросам выставления счетов и сверки взаиморасчетов, пожалуйста, пишите на: ${CONTACT_EMAIL}.`,
        ],
      },
    ],
  },
  kz: {
    title: "Жеткізу және төлем",
    updated: "Соңғы жаңарту күні: 2026 жылғы 31 тамыз",
    intro: [
      "BARCRAFT компаниясы («БАРКРАФТ» ЖШС) HoReCa секторы үшін кәсіби технологиялық жабдықты жеткізуші болып табылады. Біз тек заңды тұлғалармен және дара кәсіпкерлермен ұзақ мерзімді әрі кәсіби серіктестік аясында жұмыс істейміз.",
    ],
    sections: [
      {
        heading: "1. Төлем шарттары мен тәртібі",
        paragraphs: ["Біз әрбір серіктеске икемді қаржы саясаты мен жеке көзқарасты ұстанамыз."],
        list: [
          "Салық салу: сайттағы барлық бағалар 16% ҚҚС ескеріле отырып көрсетілген.",
          "Жеке келісім: төлеу шарттары, тәртібі және мерзімдері әрбір клиентпен жеке тәртіппен бөлек келісіледі.",
          "Шарттық негіз: төлемдер бойынша қол жеткізілген барлық уағдаластықтар (алдын ала төлем мөлшері, төлем кестесі, түпкілікті есеп айырысу шарттары) ресми Жеткізу шартында немесе тапсырысқа арналған Спецификацияда бекітіледі.",
          `Есеп айырысу нысаны: төлем қолма-қол ақшасыз тәртіппен «БАРКРАФТ» ЖШС есеп шотына аудару арқылы жүзеге асырылады (БСН: ${CONTACT_BIN}).`,
          "Валюта: Қазақстан Республикасы аумағында барлық есеп айырысулар теңгемен (KZT) жүзеге асырылады.",
        ],
      },
      {
        heading: "2. Жөнелту мерзімдері мен шарттары",
        paragraphs: ["Жеткізу мерзімі жабдықтың қоймада бар-жоғына және тапсырыстың күрделілігіне байланысты:"],
        list: [
          "Бар тауарлар: қоймадан жөнелту шарт талаптарына сәйкес төлем расталғаннан кейін 10 жұмыс күні ішінде жүзеге асырылады.",
          "Тапсырыс бойынша тауарлар: арнайы немесе күрделі технологиялық жабдықты жеткізу мерзімі 14-тен 90 күнтізбелік күнге дейін құрайды. Мерзім өндіруші зауыттың өндірістік циклына және халықаралық логистика шарттарына байланысты.",
        ],
      },
      {
        heading: "3. Тауарды жеткізу және алу",
        paragraphs: ["Біз жабдықты Қазақстан Республикасы аумағында жеткізуді ұйымдастырамыз:"],
        list: [
          "Астана қаласы бойынша жеткізу: тегін жүзеге асырылады.",
          "Қазақстан бойынша жеткізу: сіз көрсеткен кез келген көлік компаниясының (КК) Астана қаласы шегіндегі терминалына дейін тапсырысыңызды тегін жеткіземіз. Қалааралық тасымалдауды (Астанадан сіздің қалаңызға дейін) Сатып алушы таңдалған КК тарифтері бойынша өз бетінше төлейді.",
          "Өзі әкету: сіз тауарды алдын ала келісім бойынша Астана қаласындағы қоймамыздан өз бетіңізше ала аласыз.",
        ],
      },
      {
        heading: "4. Жабдықты қабылдау ережелері",
        paragraphs: ["Жабдықты алу үшін Сатып алушының өкілі мыналарды ұсынуға міндетті:"],
        list: ["ТМҚ алуға арналған сенімхаттың түпнұсқасы.", "Жеке басын куәландыратын құжат."],
      },
      {
        heading: "5. Байланыс",
        paragraphs: [
          "Қабылдау кезінде қаптаманың бүтіндігін тексеру қажет. Тауарды алып жүру құжаттарына қол қою тауардың саны мен сыртқы түріне қатысты шағымдардың жоқтығын растайды.",
          `Шот ұсыну және өзара есеп айырысуларды салыстыру мәселелері бойынша ${CONTACT_EMAIL} мекенжайына жазыңыз.`,
        ],
      },
    ],
  },
};

export default function ShippingAndPaymentPage() {
  const { language } = useLanguage();
  return <PolicyPage content={CONTENT[language]} />;
}
